import { useFlags } from 'launchdarkly-react-client-sdk'
import { ReactNode } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useGlobalStateContext } from '@/store/global/use-global-state'

interface RouteGuardProps {
  children?: ReactNode
}

export const FeatureFlagRouteGuard = ({ children }: RouteGuardProps) => {
  const { userAndCompanyHavePermissions } = useGlobalStateContext()
  const { reimbursementsModuleEnabled } = useFlags()
  // Determine if the user is allowed access and flag is on
  const isAllowed = userAndCompanyHavePermissions && reimbursementsModuleEnabled

  if (!isAllowed) {
    return <Navigate to={'/reimbursements/error'} />
  }

  return children ? <>{children}</> : <Outlet />
}
